import httpClientClubEvents from '../api/httpClientClubEvents';

export const getSummary = async () => {
  const response = await httpClientClubEvents.get(
    '/api/clubevents/ParticipationCancellationRequest/Summary',
  );
  return response.data;
};

export const getAll = async ({
  pageNumber = 1,
  pageSize = 20,
  status,
  eventId,
} = {}) => {
  const response = await httpClientClubEvents.get(
    '/api/clubevents/ParticipationCancellationRequest',
    {
      params: {
        pageNumber,
        pageSize,
        status: status != null && status !== '' ? status : undefined,
        eventId: eventId || undefined,
      },
    },
  );
  return response.data;
};

export const getById = async (id) => {
  const response = await httpClientClubEvents.get(
    `/api/clubevents/ParticipationCancellationRequest/${id}`,
  );
  return response.data;
};

export const approve = async (id, payload) => {
  const response = await httpClientClubEvents.post(
    `/api/clubevents/ParticipationCancellationRequest/${id}/approve`,
    payload,
  );
  return response.data;
};

export const reject = async (id, payload) => {
  const response = await httpClientClubEvents.post(
    `/api/clubevents/ParticipationCancellationRequest/${id}/reject`,
    payload,
  );
  return response.data;
};

export default {
  getSummary,
  getAll,
  getById,
  approve,
  reject,
};
